import { FC, useEffect } from 'react';
import { useHistory } from 'react-router';

import { handleDashboardRedirection } from 'src/apps/dashboard/helpers/NavigationHelpers';
import { isConfigurationReady, isDashboardEnabled } from 'src/common/helpers/ConfigurationHelpers';

import { useConfiguration } from '../../../providers/configurationProvider/ConfigurationProvider';
import { useUserTenant } from '../../../providers/userTenantProvider/UserTenantProvider';
import { getHomepageRedirectToLink } from '../../../services/HomePageRedirectionService';

export const DashboardContainerHome: FC = () => {
	const history = useHistory();
	const { tenant } = useUserTenant();
	const { getToggle, configuration } = useConfiguration();

	useEffect(() => {
		if (!isConfigurationReady(configuration)) {
			return;
		}

		if (isDashboardEnabled(configuration)) {
			handleDashboardRedirection(history, configuration);
			return;
		}

		const redirectTo = getHomepageRedirectToLink(tenant, getToggle);
		history.push(redirectTo);
	}, [configuration, tenant, getToggle, history]);

	return null;
};
